import { inject, InjectionToken } from '@angular/core';
import { AvatarResult, CameraService } from '../services';

export { AvatarResult } from '../services';

export const CAMERA_TOKEN: InjectionToken<CameraProvider> = new InjectionToken<CameraProvider>('CAMERA_TOKEN', {
  factory: (): CameraProvider => {
    const cameraService: CameraService = inject(CameraService);

    return {
      pickAvatar(): Promise<AvatarResult | null> {
        return cameraService.pickAvatar();
      }
    };
  }
});

export interface CameraProvider {
  pickAvatar(): Promise<AvatarResult | null>;
}
